<template>
  <div class="card image-card">
    <div class="img-holder" v-if="preview">
      <button
        type="button"
        @click="$emit('selectPhoto', param)"
        class="img-corner-btn img-edit-btn shadow rounded"
      >
        <i class="bi bi-pencil-fill"></i>
      </button>
      <button
        type="button"
        @click="$emit('removePhoto', param)"
        class="img-corner-btn img-remove-btn shadow rounded"
      >
        <i class="bi bi-x-lg"></i>
      </button>
      <img @click="$emit('previewPhoto', param)" :src="preview" :alt="title" />
    </div>
    <div class="img-holder" v-else-if="partner && partner[param]">
      <button
        type="button"
        @click="$emit('selectPhoto', param)"
        class="img-corner-btn img-edit-btn shadow rounded"
      >
        <i class="bi bi-pencil-fill"></i>
      </button>
      <img
        @click="$emit('previewPhoto', param)"
        :src="baseUrl + 'upload/' + partner[param]"
        :alt="title"
      />
    </div>
    <div class="img-holder" v-else>
      <button
        class="choose-img-btn"
        type="button"
        @click="$emit('selectPhoto', param)"
      >
        <i class="bi bi-plus-square"></i>
      </button>
    </div>
    <div class="card-body">
      <h6 class="card-title">{{ title }}</h6>
    </div>
  </div>
</template>

<script>
export default {
  props: ['param', 'preview', 'data', 'partner', 'baseUrl', 'title']
};
</script>

<style scoped>
.image-card {
  margin-bottom: 15px;
}
.image-card img,
.choose-img-btn,
.img-holder {
  width: 100%;
  height: 150px;
  object-fit: contain;
}
.image-card .choose-img-btn {
  border: none;
}
.image-card .choose-img-btn i {
  font-size: 25px;
}

.img-corner-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  font-size: 12px;
  border: none;
  color: white;
  border-radius: 100% !important;
  top: 5px;
}
.img-edit-btn {
  right: 10px;
  background-color: #0b5ed7;
}
.img-remove-btn {
  right: 38px;
  background-color: #dc3545;
}
</style>
